<template>
    <v-container class="counter-sum headline text-none text-center" :class="{ wide: goWide, negative: negativeCount }">
        <p class="mb-0 text-center" :class="{ 'subtitle-1': goWide, caption: !goWide }">
            {{ prefix }}
        </p>
        <v-row no-gutters justify="center" class="summary-row" :class="{ 'mt-3': goWide }">
            <v-col v-for="(sum, index) in sums" :key="'sum--' + index" class="flex-grow-0 flex-shrink-1 d-flex align-center px-3">
                <span class="pr-2" :data-id="`total-${sum.type}`" :class="{ 'display-1': goWide }">{{ sum.count || 0 }}</span>
                <v-icon :size="goWide ? 38 : 32">
                    {{ iconType(sum.type) }}
                </v-icon>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface CounterSum {
    count: number;
    type: string;
}

const props = defineProps<{
    sums: CounterSum[];
    prefix?: string;
}>();

const negativeCount = computed(() => {
    props.sums.forEach(sum => {
        if (sum.count < 0) {
            return true;
        }
    });
    return false;
});

const goWide = computed(() => {
    return props.sums.length > 1;
});

function iconType(type) {
    return type === 'vehicle' ? 'mdi-car' : 'mdi-human-male';
}
</script>

<style lang="scss">
.counter-sum {
    background-color: rgba(51, 63, 72, 0.08);
    height: 63px;

    p {
        padding-top: 8px;
    }

    &.wide {
        height: 104px;
    }

    &.negative {
        border: 2px solid #f70000;
        padding: 10px;
    }

    .caption {
        font-size: 0.75rem;
    }

    &.headline {
        padding-top: 0px !important;
    }

    .summary-row {
        font-size: 2.125rem;

        .v-icon::before {
            color: rgba(0, 0, 0, 0.54);
        }
    }

    &.inline-sum {
        p {
            padding-top: 0;
        }

        .summary-row {
            font-size: 1.5rem;
        }
    }
}
</style>
